import ENV_VARS from '@/config'
import { get, post, put, del } from './api'

const { BACKEND_SERVER } = ENV_VARS

export const buildRequest = url =>
  get(`${BACKEND_SERVER}/${url}`, {
    noLoading: true,
    failSilently: true
  })()

export const getSession = get(`${BACKEND_SERVER}/users/bootstrap/session`, {
  failSilently: true
})

// PAYMENT
export const connectStripe = get(`${BACKEND_SERVER}/payment_request/connect`, {
  failSilently: true
})
export const paymentStripe = post(`${BACKEND_SERVER}/payment_request/process`, {
  failSilently: true
})

// BUILDING
export const createBuilding = post(`${BACKEND_SERVER}/buildings`)
export const searchBuilding = post(`${BACKEND_SERVER}/buildings/search`, {
  noLoading: true
})

// FILES
export const uploadFile = put(`${BACKEND_SERVER}/files`)
export const updateFile = put(`${BACKEND_SERVER}/files/%fileId%`)
export const deleteFile = del(`${BACKEND_SERVER}/files/%fileId%`)
export const setCover = put(`${BACKEND_SERVER}/files/set_cover`)

export const logUserView = put(`${BACKEND_SERVER}/l/users/%userId%`, {
  noLoading: true
})

// FLAGS
export const createFlag = put(`${BACKEND_SERVER}/flags/users`)

export const deleteFlag = del(`${BACKEND_SERVER}/flags/users/%flagId%`)
export const getFlag = del(`${BACKEND_SERVER}/flags/users/%flagId%`)

// BLOCKS
export const getBlocks = get(`${BACKEND_SERVER}/blocks/usages/%block%`)
